import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsRoundcubeComponent } from './simple-icons-roundcube.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsRoundcubeComponent ],
    exports:      [ SimpleIconsRoundcubeComponent ],
    bootstrap:    []
})
export class SimpleIconsRoundcubeModule {}
